import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty';
import { login, logout, validate } from '@/api/user';
import types from '../types';
import { basicRouters, routes } from '@/router';
import { Message } from 'element-ui';
import { removeToken, setToken } from '@/utils/auth'

const state = {
  userInfo: {},
  roleIds: [],
  routers: []
};

const mutations = {
  [types.SET_USERINFO](state, user) {
    state.userInfo = user;
  },
  [types.CLEAR_LOGININFO](state) {
    state.userInfo = {};
    state.routers = [];
    state.roleIds = [];
  },
  [types.SET_ROUTERS] (state, routers) {
    state.routers = [...basicRouters, ...routers];
  },
  [types.SET_ROLEIDS] (state, roleIds) {
    state.roleIds = roleIds;
  }
}

const hasPermission = (roles, route) => {
  if (route.meta && route.meta.roles) {
    if (route.meta.isEvent) {
      return state.userInfo.roles.some(role => role.code === 'ServiceDesk')
              || (!route.meta.roles.length || roles.some(role => route.meta.roles.includes(role)));
    }
    if (route.meta.isServiceDesk) {
      return state.userInfo.roles.some(role => role.code === 'ServiceDesk');
    }
    if (route.meta.isNotServiceDesk) {
      return !state.userInfo.roles.some(role => role.code === 'ServiceDesk')
              && (!route.meta.roles.length || roles.some(role => route.meta.roles.includes(role)));
    }
    return !route.meta.roles.length || roles.some(role => route.meta.roles.includes(role));
  }
  return true;
};

const filterRoutes = (routes, roleIds) =>
  (routes.filter(v => {
    if (hasPermission(roleIds, v)) {
      if (v.children && v.children.length > 0) {
        v.children = filterRoutes(v.children, roleIds);
      }
      return v;
    }
    return false;
    // return true;
  }));
// pre.concat(Array.isArray(cur) ? flatten(cur) : [cur])
// 数组扁平化方法，内置flat函数不支持IE
const flatten = ary => ary.reduce((pre, cur) => Array.isArray(cur) ? [...pre, ...cur] : [...pre, cur]);

const actions = {
  logout ({ commit }) {
    return logout().then(res => {
      const { message } = res.data;
      commit(types.CLEAR_LOGININFO);
      removeToken();
      return message;
    });
  },
  loginForToken ({ commit }, loginData) {
    return login(loginData)
      .then(res => {
        const { data, code, message } = res.data;
        if (code === 200) {
          return res.data;
        } else {
          Message.error(message);
        }
      })
      .catch(error => {
        return Promise.reject(error);
      })
  },
  loginByToken ({ dispatch }) {
    return dispatch('getUserInfo').then(user =>
      dispatch('generateRoutes', user)
    );
  },
  getUserInfo ({ commit }) {
    return validate()
      .then(res => {
        const { data: user, message } = res.data;
        if (isEmpty(user)) {
          Message.error(message);
          return Promise.reject(message);
        }
        const { roles, status } = user;
        if (!roles) {
          Message.error('当前用户无角色');
          return Promise.reject(message);
        }
        if (status !== 'enable') {
          Message.error('当前用户已禁用');
          return Promise.reject(message);
        }
        setToken();
        commit(types.SET_USERINFO, user);
        return user;
      })
  },
  generateRoutes (context, { roles }) {
    const codes = roles.filter(role => role.status === 'enable').map(role => role.resourceCodes);
    const roleIds = Array.from(new Set(flatten(codes)));
    context.commit(types.SET_ROLEIDS, roleIds);
    return new Promise(resolve => {
      let accessedRouters = filterRoutes(cloneDeep(routes), roleIds);
      context.commit(types.SET_ROUTERS, accessedRouters);
      resolve(accessedRouters);
    })
  },
  loginForAll ({ dispatch }, loginData) {
    return dispatch('loginForToken', loginData).then(({ data }) =>
      dispatch('loginByToken')
    );
  },
};

export default {
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/base.js